var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkdIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.919922,
    width: 24.5,
    height: 24.5,
    rx: 5.75,
    fill: "#F9F9F9",
    stroke: "#CCCCCC",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3849_10097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83333 7.16992H17.1667C17.9031 7.16992 18.5 7.76688 18.5 8.50326V17.8366C18.5 18.573 17.9031 19.1699 17.1667 19.1699H7.83333C7.09695 19.1699 6.5 18.573 6.5 17.8366V8.50326C6.5 7.76688 7.09695 7.16992 7.83333 7.16992ZM9.83333 17.1699C10.0174 17.1699 10.1667 17.0207 10.1667 16.8366V12.1699C10.1667 11.9859 10.0174 11.8366 9.83333 11.8366H8.83333C8.64924 11.8366 8.5 11.9859 8.5 12.1699V16.8366C8.5 17.0207 8.64924 17.1699 8.83333 17.1699H9.83333ZM9.33333 11.1699C8.78105 11.1699 8.33333 10.7222 8.33333 10.1699C8.33333 9.61764 8.78105 9.16992 9.33333 9.16992C9.88562 9.16992 10.3333 9.61764 10.3333 10.1699C10.3333 10.7222 9.88562 11.1699 9.33333 11.1699ZM16.1667 17.1699C16.3507 17.1699 16.5 17.0207 16.5 16.8366V13.7699C16.5217 12.7105 15.7384 11.8063 14.6867 11.6766C13.9513 11.6094 13.2389 11.9529 12.8333 12.5699V12.1699C12.8333 11.9859 12.6841 11.8366 12.5 11.8366H11.5C11.3159 11.8366 11.1667 11.9859 11.1667 12.1699V16.8366C11.1667 17.0207 11.3159 17.1699 11.5 17.1699H12.5C12.6841 17.1699 12.8333 17.0207 12.8333 16.8366V14.3366C12.8333 13.7843 13.2811 13.3366 13.8333 13.3366C14.3856 13.3366 14.8333 13.7843 14.8333 14.3366V16.8366C14.8333 17.0207 14.9826 17.1699 15.1667 17.1699H16.1667Z",
    fill: "#5E5E5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3849_10097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 13,
    fill: "white",
    transform: "translate(6 6.66992)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdIcon);
export default __webpack_public_path__ + "static/media/LinkdIcon.ba5ac5f113b07ee016af0fc473076903.svg";
export { ForwardRef as ReactComponent };